import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
// import { UserProfileStoreModule } from './user-profile-store/user-profile-index';
import { StoreModule, ActionReducerMap, ActionReducer, MetaReducer } from '@ngrx/store'
import { EffectsModule } from '@ngrx/effects'
import { StoreDevtoolsModule } from '@ngrx/store-devtools'
// import { environment } from 'src/environments/environment';
import { StoreRouterConnectingModule, MinimalRouterStateSerializer } from '@ngrx/router-store'
// import {UserProfileReducers, UserProfileState} from 'src/app/root-store/user-profile-store/user-profile-index';
// import {RootStoreState} from 'src/app/root-store/root-index';
import * as RootStoreState from './root.state'
import { localStorageSync } from 'ngrx-store-localstorage'
// import { ConfigurationStoreModule, ConfigReducers } from './config-store/config-index';
import { clearState } from './meta-reducers'
import CryptUtils from '../auth/utils/crypt.utils'
import * as UserProfileReducers from './user-profile-store/user-profile.reducers'
import * as ConfigReducers from './config-store/config.reducer'
import { UserProfileStoreModule } from './user-profile-store/user-profile-store.module'
import { ConfigurationStoreModule } from './config-store/config-store.module'
// import { User } from '../jmeleon/models/user';
import { UserProfileState } from './user-profile-store/user-profile.state'
import * as PageStateReducers from './page-state-store/page-state.reducer'
import { UserProfileEffects } from './user-profile-store/user-profile.effects'
import { ConfigEffects } from './config-store/config.effects'
import { CatalogueStoreModule } from './catalogue-store/catalogue-store.module'
import { CatalogueReducers } from './catalogue-store/catalogue-index'
import { CatalogueEffects } from './catalogue-store/catalogue.effects'
import { DtoStoreModule } from './dto-store/dto-store.module'
// import * as DtoReducers from './dto-store/dto.reducer';
import { DtoReducers } from './dto-store/dto.index'
import { DtoEffects } from './dto-store/dto.effects'
import { SettingReducers } from './setting-store/setting-index'
import { SettingEffects } from './setting-store/setting.effects'

const reducers: ActionReducerMap<RootStoreState.State> = {
  // userProfile: UserProfileReducers.userProfileReducer,
  // config: ConfigReducers.configReducer
  userProfile: UserProfileReducers.publicUserProfileReducer,
  config: ConfigReducers.publicConfigReducer,
  pageState: PageStateReducers.reducer,
  catalogue: CatalogueReducers.publicCatalogueReducer,
  dto: DtoReducers.reducer,
  setting: SettingReducers.publicSettingReducer
}

export function localStorageSyncReducer(reducer: ActionReducer<any>): ActionReducer<any> {
  const jmeleonStoreNames = [
    {
      userProfile: {
        // en-/decrypt is not called when used with de-/serialize. moved en/decrypt into de-/serialize.
        // encrypt: (state: string) => CryptUtils.encryptForLocalStorage(state),
        // decrypt: (state: string) => CryptUtils.decryptForLocalStorage(state),
        serialize: (userState: UserProfileState) => {
          // clone state
          // console.log('serializing state. input: ', userState);
          const state = JSON.parse(JSON.stringify(userState))
          // remove unwanted properties
          if (!!state.user) {
            state.user.allowedActions = []
            state.user.roles = []
            state.user.user = undefined
            state.tokenIsValidated = false
          }
          if (!!state && !!state.user && !!state.user.token) {
            state.user.token = CryptUtils.encryptToken(state.user.token)
          }
          return state
          // serialize (doesn't seems to be necessary)
          // console.log('serializing state. ', state);
          // return JSON.stringify(state);
        },
        deserialize: (state) => {
          // console.log('deserializing state. ', state);
          // return JSON.parse(state);
          if (!!state && !!state.user && !!state.user.token) {
            state.user.token = CryptUtils.decryptToken(state.user.token)
          }
          return state
        }
      }
    },
    {
      config: {}
    }
  ]
  const customStoreNames = []
  return localStorageSync({
    keys: jmeleonStoreNames.concat(customStoreNames),

    rehydrate: true
  })(reducer)
}

export function sessionStorageSyncReducer(reducer: ActionReducer<any>): ActionReducer<any> {
  return localStorageSync({ keys: ['pageState'], rehydrate: true, storage: sessionStorage })(reducer)
}

const metaReducers: Array<MetaReducer<any, any>> = [localStorageSyncReducer, sessionStorageSyncReducer, clearState]

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forRoot(
      reducers,
      // undefined,
      { metaReducers }
    ),
    EffectsModule.forRoot([UserProfileEffects, ConfigEffects, CatalogueEffects, SettingEffects, DtoEffects]),
    // StoreDevtoolsModule.instrument({ maxAge: 25, logOnly: environment.production }),
    StoreDevtoolsModule.instrument({ maxAge: 25, logOnly: false }),

    StoreRouterConnectingModule.forRoot({ serializer: MinimalRouterStateSerializer }),
    UserProfileStoreModule,
    ConfigurationStoreModule,
    CatalogueStoreModule,
    DtoStoreModule
  ]
})
export class RootStoreModule {}
